





























import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import * as data from "../../_store/data.module";
import { router } from "../../_router";
import * as user from "../../_store/user.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";

@Component({
  components: {
    CardTitle
  }
})
export default class CurriculumAnno extends Vue {
  @Prop() idIstituto!: number;
  private titleParams: object;
  private listaAnni: any[];
  private isComplete: boolean;

  constructor() {
    super();
    this.titleParams = {
      title: "Curriculum Vitae",
      cols: "12",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.listaAnni = [];
    this.isComplete = false;
  }

  checkValid(IdAnnoScolastico: number) {
    var userInfo = user.readUserInfo(this["$store"]);
    var idIstitutoString: string = String(this.idIstituto);
    var idAnnoScolasticoString: string = String(IdAnnoScolastico);
    if (userInfo.tipoSoggetto === 3){
      var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
      var payload = {
        idAzienda: enterpriseInfo.idAzienda,
        idIstituto: this.idIstituto
      };
      this.isComplete = userUtils.checkEnterpriseInfo(enterpriseInfo);
      if (this.isComplete !== false) {
        data
          .dispatchRespDoc(this["$store"], payload)
          .then(response => {
            if (
              response.IdDocNominaResponsabile !== undefined &&
              response.IdDocNominaResponsabile !== null
            ) {
              if (response.StatoDocumento === 2) {
                router.push({
                  name: "curriculumVitaeArticolazioni",
                  params: {
                    idIstituto: idIstitutoString,
                    idAnnoScolastico: idAnnoScolasticoString
                  }
                });
              } else {
                bus.$emit(
                  "noDoc",
                  "E' necessario attendere la verifica del documento per la nomina del responsabile trattamento dati"
                );
              }
            } else {
              bus.$emit(
                "noDoc",
                "E' necessario compilare il documento per la nomina del responsabile trattamento dati. Questo si può trovare nella sezione 'Amministrazione'/'Moduli'"
              );
            }
          })
          .catch(error => {
            if (error.response.status === 401) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      } else {
        bus.$emit("incompleteInfo");
      }
    } else if(userInfo.tipoSoggetto === 2){
      var instituteInfo = user.readInstituteInfo(this["$store"])
      if (instituteInfo.id == this.idIstituto){
        router.push({
          name: "curriculumVitaeArticolazioni",
            params: {
              idIstituto: idIstitutoString,
              idAnnoScolastico: idAnnoScolasticoString
            }
          });
      }
    }
  }

  // select(IdAnnoScolastico: number) {
  //   var idIstitutoString: string = String(this.idIstituto);
  //   var idAnnoScolasticoString: string = String(IdAnnoScolastico);
  //   router.push({
  //     name: "curriculumVitaeArticolazioni",
  //     params: {
  //       idIstituto: idIstitutoString,
  //       idAnnoScolastico: idAnnoScolasticoString
  //     }
  //   });
  // }

  created() {
    var payload = {
      idIstituto: this.idIstituto
    };
    data
      .dispatchCurriculumAnni(this["$store"], payload)
      .then(result => {
        this.listaAnni = result;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }
}
